import { DataTableSkeleton } from '@Components/General/Skeletons'
import { createFileRoute } from '@tanstack/react-router'
import { expensesQueryOptions } from '@utils/queryOptions'
import ContactDonations from '@Views/Contacts/Contacts/ContactDetails/ContactDonations'

export const Route = createFileRoute('/contacts/$contactId_/expenses')({
  component: ContactDonations,
  loader: (opts) =>
    opts.context.queryClient.ensureQueryData(expensesQueryOptions(opts.deps)),
  loaderDeps: ({ search }) => search,
  pendingComponent: DataTableSkeleton,
})
